"use client";

import { useCabinet } from "~/app/[lang]/(default)/product/[id]/variant/Cabinets/Context";
import type { ServerFurnitureConfiguratorProps } from "~/components/configurator/utilities";
import {
	BaseFurnitureConfigurator,
	type BaseFurnitureConfiguratorProps,
} from "./BaseFurnitureConfigurator";

type Props = ServerFurnitureConfiguratorProps & BaseFurnitureConfiguratorProps;

export function PdpFurnitureConfigurator(props: Props) {
	const { setStore, setApi, orderData } = useCabinet();

	return (
		<BaseFurnitureConfigurator
			{...props}
			variant="cabinet"
			item={{
				orderData: props.item?.orderData ?? orderData,
				...props.item,
			}}
			onStoreChange={(store, api) => {
				setStore(store);
				setApi(api);
			}}
		/>
	);
}
